export interface QuoteViewModel {
  id: number;
  quoteId: number;
  idNumber: string;
  firstName: string;
  lastName: string;
  cellNumber: string;
  loanPurpose: string;
  status: string;
  clientNumber: number;
  userName: string;
  branchName: string;
}

export class QuoteModel implements QuoteViewModel {
  id!: number | 0;
  quoteId: number;
  idNumber: string;
  firstName: string;
  lastName: string;
  capital: number;
  cellNumber: string;
  loanPurpose: string;
  status: string;
  userName: string;
  branchName: string;
  clientNumber: number;
  clientStatus: string;
  rejectOfferReason: string;
  rejectCompliance: string;
  rejectOtherReason: string;
  branchSerial: any;
  branchSerialNumber: any;
  myBenefitsOption: any;
  clientType: any;
  employerName: string;
  offer: any[];
  allowedProducts: any[];
  isConfirmedAddressDetails: boolean;
  isConfirmedEmploymentDetailsDetails: boolean;
  isConfirmedBankingDetails: boolean;
  isConfirmedNokDetails: boolean;
  isConfirmedDocScanningDetails: boolean;
  loanProcessingConfirmed: boolean = false;
  newLoanProcessingConfirmed: boolean = false;
  initiatedBy?: string;
  ltApprovalStatus?: 'pending' | 'approved' | 'rejected' | null;
  ltApprovalType?: 'BM' | 'AM' | 'RM' | null;
  ltApprovedBy?: string;
  ltApprovalDate?: Date;
  employment?: any;

}
